import React from "react";
import CountdownTimer from "./CountdownTimer";
import EventDetail from "./EventDetail";
import { useSelector } from "react-redux";

function EventDetailPage(props) {
    const isTimer = useSelector((state) => state.timer.isTimer);
    const booking = useSelector((state) => state.event.booking);

  return (
    <>
      {isTimer && booking && <CountdownTimer />}
      <EventDetail pageTitle={props.pageTitle} />
    </>
  );
}

export default EventDetailPage;
